import { Fragment, FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Button } from "primereact/button";
import { Message } from "primereact/message";

import { translationKeys } from "../../../models/app-translation-keys";
import { useStore } from "../../../stores/StoreContext";

import "./GlobalErrorMessages.scss";

interface IGlobalErrorMessagesProps {
  children?: (content: ReactNode) => ReactNode;
}

const RawGlobalErrorMessages: FunctionComponent<IGlobalErrorMessagesProps> = ({
  children,
}: IGlobalErrorMessagesProps) => {
  const { t } = useTranslation();
  const { globalErrorsStore } = useStore();

  if (!globalErrorsStore.hasErrors) {
    return;
  }

  children ??= content => content;

  return children(
    <div className="global-errors">
      {globalErrorsStore.currentErrors.map(({ key, data, allowClosing }) => (
        <Message
          key={key}
          severity="error"
          className="global-error"
          text={allowClosing ? undefined : (t(key, data) as string)}
          content={
            allowClosing ? (
              <Fragment>
                <span className="global-error-message-text">{t(key, data) as string}</span>
                <Button
                  icon="pi pi-times"
                  text
                  className="global-error-close-button"
                  onClick={() => globalErrorsStore.removeError(key)}
                  aria-label={t(translationKeys.actions.close)}
                />
              </Fragment>
            ) : undefined
          }
        />
      ))}
    </div>,
  );
};

export const GlobalErrorMessages = observer(RawGlobalErrorMessages);
